module.exports = __webpack_public_path__ + "img/icon-vot-addinfo.da284f88.png";